import React, { Component } from "react";
import Chart from "react-apexcharts";
import { Row, Col, Card, CardBody } from 'reactstrap'
import axios from 'axios'
import { loginNodeBaseURL } from "ApiURL";
import CardHeader from "reactstrap/lib/CardHeader";
import moment from "moment";
import { connect } from 'react-redux'
import { getConvertedTime, comparisonGraphTimeFormat } from "utilFunctions/getConvertedTime";

const mapStateToProps = (state) => {
    return {
        companyServices: state.services.companyServices,
        outletCode: state.outletCode.outletCode
    }
}

class ComparisonGraph extends Component {
    constructor(props) {
        super(props);
        this.state = {
            day: [0],
            week: [0],
            month: [0],
            hourLabels: [
                '00:00', '01:00', '02:00', '03:00', '04:00', '05:00',
                '06:00', '07:00', '08:00', '09:00', '10:00', '11:00',
                '12:00', '13:00', '14:00', '15:00', '16:00', '17:00',
                '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'
            ].map(item => {
                return getConvertedTime(
                    moment.utc(`${new Date(Date.now()).toLocaleDateString()} ${item}`, "YYYY-MM-DD HH"),
                    props.companyServices[props.outletCode] ? props.companyServices[props.outletCode].timezone : null,
                    comparisonGraphTimeFormat)
            })
        };
        this._ismounted = true
    }

    fetchData = (route, outletCode) => {
        axios.get(`${loginNodeBaseURL}${route}/${outletCode}/`)
            .then(res => {
                this._ismounted && this.setState({
                    day: Object.values(res.data.day).map(i => { return i.toFixed(0) }),
                    week: Object.values(res.data.week).map(i => { return i.toFixed(0) }),
                    month: Object.values(res.data.month).map(i => { return i.toFixed(0) }),
                    // hourLabels: Object.keys(res.data.day)
                })
            })
            .catch(err => {

            })
    }

    componentDidMount() {
        this._ismounted && this.fetchData(this.props.route, this.props.outletCode)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this._ismounted && this.fetchData(nextProps.route, nextProps.outletCode)
    }

    render() {
        let series = [{
            name: 'Today',
            type: 'line',
            data: this.state.day,
        }, {
            name: 'Last 7 Days',
            type: 'area',
            data: this.state.week
        }, {
            name: 'Last 30 Days',
            type: 'line',
            data: this.state.month
        }]
        let options = {
            chart: {
                height: 'auto',
                type: 'line',
                stacked: false,
                toolbar: {
                    show: true,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                        download: true,
                        selection: true,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: false,
                        reset: true | '<img src="/static/icons/reset.png" width="20">',
                        customIcons: []
                    },
                    export: {
                        csv: {
                            filename: undefined,
                            columnDelimiter: ',',
                            headerCategory: 'category',
                            headerValue: 'value',
                            dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                            }
                        },
                        svg: {
                            filename: undefined,
                        },
                        png: {
                            filename: undefined,
                        }
                    },
                    autoSelected: 'zoom'
                },
            },
            stroke: {
                width: [3, 2, 3],
                curve: 'smooth',
                dashArray: [3, 3, 3]
            },
            plotOptions: {
                bar: {
                    columnWidth: '50%'
                }
            },

            fill: {
                opacity: [0.85, 0.25, 1],
                gradient: {
                    inverseColors: false,
                    shade: 'light',
                    type: "vertical",
                    opacityFrom: 0.85,
                    opacityTo: 0.55,
                    stops: [0, 100, 100, 100]
                }
            },
            labels: this.state.hourLabels,
            markers: {
                size: 0
            },
            xaxis: {
                title: {
                    text: 'Hourly Averages',
                },
                type: 'category'
            },
            yaxis: {
                title: {
                    text: this.props.dataType,
                },
                min: 0
            },
            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: function (y) {
                        if (typeof y !== "undefined") {
                            return y.toFixed(0) + ' Count';
                        }
                        return y;
                    }
                }
            }
        }
        return (
            <div>
                <Row>
                    <Col>
                        <Card>
                            <CardHeader className='h3'>
                                Hourly averages of last 7 days to last 30 days
                                <span className='h5'>(in outlet timezone)</span>

                            </CardHeader>
                            <CardBody>
                                <Chart
                                    options={options}
                                    series={series}
                                    type="line"
                                    width="100%"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div >
        );
    }
}

export default connect(
    mapStateToProps
)(ComparisonGraph);